// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-delete-modal .delete-modal-content{padding-left:4px;margin-bottom:40px}@media only screen and (min-width: 1200px){.notification-delete-modal.ui.tiny.modal.gf-modal{width:600px}}", ""]);
// Exports
module.exports = exports;
